import React, { useState } from "react";
import CategoriasAdicionar from "../CategoriasAdicionar";
import CategoriasLista from "../CategoriasLista";
import { Box } from "@mui/material";

interface CategoriasProps {
  token: string;
}

const Categorias: React.FC<CategoriasProps> = ({ token }) => {
  const [shouldUpdateList, setShouldUpdateList] = useState<boolean>(false);
  const [shouldUpdateListAdd, setShouldUpdateListAdd] =
    useState<boolean>(false);

  const atualizarCategorias = async () => {
    setShouldUpdateList((prev) => !prev);
  };

  const handleUpdateCategorie = () => {
    setShouldUpdateListAdd((prev) => !prev);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <CategoriasAdicionar
        token={token}
        atualizarCategorias={atualizarCategorias}
        shouldUpdateListAdd={shouldUpdateListAdd}
      />
      <CategoriasLista
        token={token}
        shouldUpdateList={shouldUpdateList}
        updateAddCategories={handleUpdateCategorie}
      />{" "}
      {/* Passando isLoading */}
    </Box>
  );
};

export default Categorias;
